<template>
    <el-card
      shadow="never">
        <el-form
          :model="form"
          ref="form"
          label-width="100px"
        >
            <el-form-item
              prop="name"
              label="员工姓名"
            >
                <el-input type="text" v-model="form.name" placeholder="请填写员工姓名" readonly></el-input>
            </el-form-item>
            <el-upload
              class="avatar-uploader"
              :action="appApi"
              accept="image" disabled>
                <img v-if="imageUrl" :src="imageUrl" class="avatar" disabled>
                <span v-if="!imageUrl" class="avatar-uploader-icon">暂无图片</span>
            </el-upload>
            <el-form-item
              class="customizeCss"
              prop="phone"
              label="联系方式"
            >
                <el-input type="text" v-model="form.phone" placeholder="请填写联系方式" readonly></el-input>
            </el-form-item>
            <el-form-item
              prop="employeeNo"
              label="员工编号"
            >
                <el-input type="text" v-model="form.employeeNo" placeholder="请填写员工编号" readonly></el-input>
            </el-form-item>
            <el-form-item
              prop="deptId"
              label="部门"
            >
                <el-select v-model="form.deptId" placeholder="请选择部门" disabled >
                    <el-option
                      v-for="item in deptOptions"
                      :key="item.deptId"
                      :label="item.name"
                      :value="item.deptId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item
              prop="typeId"
              label="级别"
            >
                <el-select v-model="form.typeId" placeholder="请选择员工级别" disabled >
                    <el-option
                      v-for="item in typeOptions"
                      :key="item.typeId"
                      :label="item.name"
                      :value="item.typeId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item  class="customizeCssArea" prop="cardCode" label="证件号">
                <el-input v-model="form.cardCode" placeholder="请输入证件号" readonly></el-input>
            </el-form-item>
            <el-form-item
              prop="sex"
              label="性别"
            >
                <el-select v-model="form.sex" clearable placeholder="请选择性别" disabled >
                    <el-option
                      v-for="item in sexFlag"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item  class="customizeCssArea" prop="experienceCode" label="从业经验">
                <el-select v-model="form.experienceCode" clearable placeholder="请选择从业经验" disabled >
                    <el-option
                      v-for="item in experienceCodeOptions"
                      :key="item.dictItemCode"
                      :label="item.dictItemName"
                      :value="item.dictItemCode"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item
              prop="birthday"
              label="阳历生日"
            >
                <el-date-picker
                  v-model="form.birthday"
                  :editable="false"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期" readonly>
                </el-date-picker>
            </el-form-item>
            <el-form-item
              label="区域"
              class="customizeCssArea"
              prop="regionCode">
                <el-cascader
                  :options="regionOptions"
                  change-on-select
                  :value="regionValue"
                  :props="defaultRegionProps"
                  disabled></el-cascader>
            </el-form-item>
            <el-form-item
              prop="addr"
              class="ipt-textarea"
              label="详细地址"
            >
                <el-input type="textarea" v-model="form.addr" placeholder="请填写详细地址" readonly></el-input>
            </el-form-item>
            <el-form-item
                          prop="nationCode"
                          label="民族"
            >
                <el-input v-model="form.nationCode" placeholder="请输入民族" readonly></el-input>
            </el-form-item>
            <el-form-item class="customizeCssArea"
              prop="politicalCode"
              label="政治面貌"
            >
                <el-select v-model="form.politicalCode" clearable placeholder="请选择政治面貌" disabled>
                    <el-option label="群众" value="1"></el-option>
                    <el-option label="团员" value="2"></el-option>
                    <el-option label="预备党员" value="3"></el-option>
                    <el-option label="党员" value="4"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item
              prop="merryCode"
              label="婚姻状况"
            >
                <el-select v-model="form.merryCode" clearable placeholder="请选择婚姻状况" disabled>
                    <el-option label="未婚" value="1"></el-option>
                    <el-option label="已婚" value="2"></el-option>
                    <el-option label="离婚" value="3"></el-option>
                    <el-option label="丧偶" value="4"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item
              prop="civilizationCode" class="customizeCssArea"
              label="文化程度"
            >
                <el-select v-model="form.civilizationCode" clearable placeholder="请选择文化程度" disabled>
                    <el-option label="初中及以下" value="1"></el-option>
                    <el-option label="中专" value="2"></el-option>
                    <el-option label="高中" value="3"></el-option>
                    <el-option label="大专" value="4"></el-option>
                    <el-option label="本科" value="5"></el-option>
                    <el-option label="研究生" value="6"></el-option>
                    <el-option label="博士及以上" value="7"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item
              prop="urgentPerson"
              label="紧急联系人"
            >
                <el-input v-model="form.urgentPerson" placeholder="请输入紧急联系人" readonly></el-input>
            </el-form-item>

            <el-form-item class="customizeCssArea"
                          prop="urgentPhone"
              label="紧急联系电话"
            >
                <el-input v-model="form.urgentPhone" placeholder="请输入紧急联系人电话" readonly></el-input>
            </el-form-item>
            <el-form-item
              prop="serviceRange"
              label="服务范围"
              class="ipt-textarea"
            >
                <el-input type="textarea" v-model="form.serviceRange" placeholder="请填写服务范围" resize="none" readonly></el-input>
            </el-form-item>
            <el-form-item
              prop="workHistory"
              label="工作经验"
              class="ipt-textarea"
            >
                <el-input type="textarea" v-model="form.workHistory" placeholder="请填写工作经验" resize="none" readonly></el-input>
            </el-form-item>
            <el-form-item  class="ipt-textarea"
                           prop="certificate"
                           label="证书"
            >
                <img :src="item.url"  :key="item.url" v-for="item in filelist" class="img" />
            </el-form-item>
            <el-form-item
              prop="remark"
              label="备注"
              class="ipt-textarea"
            >
                <el-input type="textarea" v-model="form.remark" placeholder="请填写备注" resize="none" readonly></el-input>
            </el-form-item>

            <div class="tc">
                <el-button
                  style="width: 140px"
                  v-on:click="goBack">关闭
                </el-button>
            </div>
        </el-form>
    </el-card>
</template>

<script>
import {employee, dict} from '../../api'
import {validImage, toolbarOptions, quillUploadSuccess} from '@/utils'

export default {
  name: 'EmployeeDetail',
  props: {
    employeeId: String
  },
  mounted () {
    this.getRegion()
    this.getExperienceCode()
    this.getDeptList()
    this.getTypeList()
    this.getDetailData()
  },
  data () {
    return {
      appApi: process.env.VUE_APP_API + '/upload/image/single/',
      defaultRegionProps: {
        value: 'id',
        label: 'name'
      },
      sexFlag: [{
        id: '1', name: '男'
      }, {
        id: '0', name: '女'
      }],
      deptOptions: [],
      typeOptions: [],
      experienceCodeOptions: [],
      regionOptions: [],
      regionValue: [],
      imageUrl: '',
      filelist: [], // 展示上传的图片
      distType: 'EXPERIENCE_CODE',
      form: {
        orgCode: this.$store.state.user.orgCode,
        employeeId: '',
        deptId: '',
        typeId: '',
        name: '',
        phone: '',
        headImg: '',
        sex: '1',
        employeeNo: '',
        cardCode: '',
        solarFlag: true,
        birthday: '',
        province: '',
        city: '',
        county: '',
        regionCode: '',
        addr: '',
        nationCode: '',
        merryCode: '',
        experienceCode: '',
        civilizationCode: '',
        politicalCode: '',
        urgentPerson: '',
        urgentPhone: '',
        serviceRange: '',
        workHistory: '',
        certificate: '',
        createUser: this.$store.state.user.userId,
        remark: ''
      }
    }
  },
  methods: {
    async getRegion () {
      this.loading = true
      let {data} = await dict.getRegion()
      this.regionOptions = data
      this.loading = false
    },
    async getExperienceCode () {
      this.loading = true
      let {data} = await dict.getDictList({'dictTypeCode': this.distType})
      this.experienceCodeOptions = data
      this.loading = false
    },
    async getDeptList () {
      this.loading = true
      let {data} = await employee.getDeptList({orgCode: this.form.orgCode})
      this.deptOptions = data
      this.loading = false
    },
    async getTypeList () {
      this.loading = true
      let {data} = await employee.getTypeList({orgCode: this.form.orgCode})
      this.typeOptions = data
      this.loading = false
    },
    async getDetailData () {
      this.loading = true
      let {data} = await employee.getEmployeeDetail(this.employeeId)
      this.loading = false
      this.regionValue = data.regionCodes
      this.employeeNo = data.employeeNo
      if (data.headImg) {
        this.imageUrl = process.env.VUE_APP_IMG + data.headImg
      } else {
        this.imageUrl = ''
      }
      if (data.certificate) {
        let imgs = data.certificate.split(',')
        this.listImgUrl = imgs
        this.filelist = imgs.map(x => ({name: x, url: process.env.VUE_APP_IMG + x}))
      }
      delete data.createTime
      this.form = data
    },
    goBack () {
      this.$closeCurrentView()
      this.$router.back()
    }
  }
}
</script>
<style lang="scss" scoped>
    .el-card {
        border: none;
        /deep/ .el-card__body {
            padding-top: 30px;
            .el-form {
                &.el-form--inline {
                    width: 745px;
                }
                .el-form-item__content,
                .el-date-editor.el-input,
                .el-input--suffix {
                    width: 232px;
                }
                .ipt-textarea {
                    display: block;
                    .el-form-item__content {
                        width: 575px;
                    }
                }
            }
            .el-upload,
            .el-upload--text {
                margin-left: 410px;
                margin-top: -58px;
            }
            .customizeCss {
                margin-top: -125px;
            }
            .customizeCssArea {
                margin-left: 350px;
                margin-top: -58px;
            }
            .zs-upload{
                .el-upload,
                .el-upload--text {
                    margin-left: 16px;
                    margin-top: 0px;
                }
            }
            .el-upload-list--picture-card .el-upload-list__item,
            .el-upload--picture-card{
                width: 80px;
                height: 80px;
            }
        }
    }

    .el-input__icon {
        margin-right: 8px;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        display: block;
        font-size: 14px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px !important;;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    .img {
        width: 80px;
        height: 80px;
        padding: 0 4px;
    }
</style>
